// extracted by mini-css-extract-plugin
export default {"modal_wrap":"modal_wrap__yTZkq","modal":"modal__5W6CP","modal_title":"modal_title__ffucv","modal-close":"modal-close__LYHIe","modal-container":"modal-container__iAq7L"};